import { SOCIAL_BUTTON_PROVIDERS } from 'js/src/components/auth/common/SocialButton';

export type LoginMethod = SOCIAL_BUTTON_PROVIDERS | 'email';

const STORAGE_KEY = 'lumen5_last_login_method';

export const getLastLoginMethod = (): LoginMethod | null => {
    try {
        const value = localStorage.getItem(STORAGE_KEY);
        if (
            value === SOCIAL_BUTTON_PROVIDERS.GOOGLE ||
            value === SOCIAL_BUTTON_PROVIDERS.FACEBOOK ||
            value === SOCIAL_BUTTON_PROVIDERS.SSO ||
            value === 'email'
        ) {
            return value;
        }
        return null;
    } catch {
        return null;
    }
};

export const setLastLoginMethod = (method: LoginMethod): void => {
    try {
        localStorage.setItem(STORAGE_KEY, method);
    } catch {
        // localStorage unavailable
    }
};
